require("../../../static/js/generic-invisible-recaptcha-v2.js");
